import React, { useEffect } from "react";
import DataTable from "../../components/data-table/data-table.component";
import { Button, Input, Select } from "antd";
import { useNavigate } from "react-router-dom";

const ShoppingPage = () => {
    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState([
        {
            orderNumber: "ORDER3245434",
            description: "Basic for price",
            theway: "Online payments",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            status: "Confirmed",
            paymentDate: "-",//-
            createDate: "2024-11-01",
        },
        {
            orderNumber: "ORDER3245434",
            description: "Premium for price",
            theway: "Online payments",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            status: "Delivered",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
        {
            orderNumber: "ORDER3245434",
            description: "Basic for price",
            theway: "Payment failed	",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            status: "Confirmed",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
        {
            orderNumber: "ORDER3245434",
            description: "Premium for price",
            theway: "Payment cancelled	",
            paymentMethod: "Online payments",
            paymentAmount: "Order online - FPS Payment",
            member: "280",//HKD280.00
            orderNum: "2024110133431",
            status: "Delivered",
            paymentDate: "2024-11-10",//-
            createDate: "2024-11-01",
        },
    ]);
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 5000);
    }, [])

    const tableSettings = {
        appendable: false,
        removable: false,
        bordered: true,
        size: "small",
        pagination: {
          showLessItems: true,
          pageSize: 10,
        },
        columns: [
          {
            title: <span style={{textWrap: "nowrap"}}>Order Number</span>,
            dataIndex: 'orderNumber',
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Order Description</span>,
            dataIndex: 'description',
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Quantity</span>,
            render: (_, record) => {
                return <>
                 <span className="cursor-pointer"
                  >
                    6
                  </span>
                </>
              },
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Price</span>,
            render: (_, record) => {
                return <>
                 <span className="cursor-pointer"
                  >
                    $200
                  </span>
                </>
              },
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Status</span>,
            dataIndex: 'status',//size
          },
          {
            title: <span style={{textWrap: "nowrap"}}>Action</span>,
            render: (_, record) => {
                return <>
                 <span className="cursor-pointer"
                  //   loading={buttonLoading[record.orderID] || false}
                    onClick={() => {
                        navigate(`/shopping/view?orderNumber=${record.orderNumber}`)
                    }}
                    target="_blank"
                  >
                    View
                  </span>
                </>
              },
          },
        ],
      };

    return (
        <div className="container box-shadow h-100" 
        style={{
            background: "0% 0% no-repeat padding-box padding-box rgb(240, 242, 245)", 
            padding: "32px",
            overflow: "auto"
            }}>

            <div className="w-100">
                <h2 className="text-start">Shopping Management</h2>
            </div>

            <div className="w-100">
                <div className="w-100">
                    <div className="d-flex justify-content-between mt-3 mb-3">
                        <div className="d-flex align-items-center">
                            <Input.Search
                                placeholder="Search Order"
                                size="large"
                                disabled={loading}
                                loading={loading}
                                className="me-2"
                                allowClear
                                style={{ width: '20rem' }}
                            // onChange={(e) => debouncedSearch(e.target.value)}
                            // onSearch={async (value) => await immediateSearch(value, false)}
                            />
                            {/* <Select
                                size={'large'}
                                // value={selectedLocation}
                                style={{ width: 350 }}
                                // onChange={(value) => setSelectedLocation(value)}
                                // options={locationOptions}
                                disabled={loading}
                                loading={loading}
                                placeholder={loading ? 'Fetching Locations' : 'Select Type'}
                            /> */}
                        </div>
                        <div>
                            {/* <Button type="primary" size={'large'}
                                onClick={() => navigate("/shopping/view")}
                            >
                                + New Shopping
                            </Button> */}
                        </div>
                    </div>
                </div>

                <div className="w-100">
                    <DataTable
                        loading={loading}
                        data={data}
                        settings={tableSettings}
                    />
                </div>

            </div>
        </div>
    )
}

export default ShoppingPage